import { GENERAL_REQUEST } from "../actions/utilities";

const INITIAL_STATE = {
  fileList: [],
};

export const generalReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GENERAL_REQUEST.SET_UPLOADED_FILE:
      if (action.payload.length) {
        state.fileList = [...state.fileList, ...action.payload];
      }
      return {
        ...state,
      };
    case GENERAL_REQUEST.REMOVE_UPLOADED_FILE:
      if (action.payload) {
        let array = state.fileList.filter((item) => {
          return item.fileName !== action.payload.filename;
        });

        state.fileList = array;
      }
      return {
        ...state,
      };
    case GENERAL_REQUEST.RESET_UPLOADED_FILE:
      return {
        ...state,
        fileList: [],
      };
    default:
      return state;
  }
};
